import {CommonConstants} from './common-constants.enum';
import {Injectable} from '@angular/core';
import {ActionState} from './action-state.enum';
import {NotificationType} from './notification-type.enum';
import * as _ from "lodash";
import { DialogType } from './dialog-type.enum';

@Injectable()
export class CommonInits {

  // Initial confirm dialog for perform any function
  public static confirmDialogForPerformAct(actionName: ActionState, multiple?: boolean) {
      switch (actionName) {
          case ActionState.DELETE: {
              if (multiple) {
                  return {
                      modalData: {
                          title: CommonConstants.DELETE_TITLE_MESG,
                          notifyMessage: CommonConstants.DELETE_NOTIFY_MESG_MULTIPLE,
                          nameButtonCancel: CommonConstants.DIALOG_CANCEL_BUTTON,
                          nameButtonAction: CommonConstants.DIALOG_DELETE_BUTTON
                      }
                  };
              } else {
                  return {
                      modalData: {
                          title: CommonConstants.DELETE_TITLE_MESG,
                          notifyMessage: CommonConstants.DELETE_NOTIFY_MESG_SINGLE,
                          nameButtonCancel: CommonConstants.DIALOG_CANCEL_BUTTON,
                          nameButtonAction: CommonConstants.DIALOG_DELETE_BUTTON
                      }
                  };
              }
          }
      }
  }

  // Initial information dialog for failed action
  public static inforDialogForFailedAct(actionName: ActionState, multiple?: boolean) {
      switch (actionName) {
          case ActionState.DELETE: {
              if (multiple) {
                  return {
                      data: {
                          headerName: CommonConstants.DELETE_FAILED_HEADER,
                          content: CommonConstants.DELETE_FAILED_CONTENT_MULTIPLE,
                          dialogType: DialogType.ERROR,
                          buttonName: CommonConstants.DIALOG_CLOSE_UPPER_BUTTON,
                          iconUrl: CommonConstants.ERROR_DIALOG_ICON_URL
                      }
                  };
              } else {
                  return {
                      data: {
                          headerName: CommonConstants.DELETE_FAILED_HEADER,
                          content: CommonConstants.DELETE_FAILED_CONTENT_SINGLE,
                          dialogType: DialogType.ERROR,
                          buttonName: CommonConstants.DIALOG_CLOSE_UPPER_BUTTON,
                          iconUrl: CommonConstants.ERROR_DIALOG_ICON_URL
                      }
                  };
              }
          }
          case ActionState.UPDATE: {
              return {
                  data: {
                      headerName: CommonConstants.UPDATE_FAILED_HEADER,
                      content: CommonConstants.SAVE_FAILED_CONTENT,
                      dialogType: DialogType.ERROR,
                      buttonName: CommonConstants.DIALOG_CLOSE_UPPER_BUTTON,
                      iconUrl: CommonConstants.ERROR_DIALOG_ICON_URL
                  }
              };
          }
          case ActionState.NEW: {
              return {
                  data: {
                      headerName: CommonConstants.CREATE_FAILED_HEADER,
                      content: CommonConstants.SAVE_FAILED_CONTENT,
                      dialogType: DialogType.ERROR,
                      buttonName: CommonConstants.DIALOG_CLOSE_UPPER_BUTTON,
                      iconUrl: CommonConstants.ERROR_DIALOG_ICON_URL
                  }
              };
          }
      }
  }

  // Initial confirm dialog for unsaved data
  public static confirmDialogForUnsavedData(actionName: ActionState) {
      switch (actionName) {
          case ActionState.REFRESH: {
              return {
                  modalData: {
                      title: CommonConstants.UNSAVED_TITLE,
                      notifyMessage: CommonConstants.UNSAVED_MESG_ON_REFRESH,
                      nameButtonCancel: CommonConstants.DIALOG_CANCEL_BUTTON,
                      nameButtonAction: CommonConstants.DIALOG_REFRESH_BUTTON
                  }
              };
          }

          case ActionState.CLOSE: {
              return {
                  modalData: {
                      title: CommonConstants.UNSAVED_TITLE,
                      notifyMessage: CommonConstants.UNSAVED_MESG_ON_CLOSE,
                      nameButtonCancel: CommonConstants.DIALOG_CANCEL_BUTTON,
                      nameButtonAction: CommonConstants.DIALOG_CLOSE_BUTTON
                  }
              };
          }
      }
  }

  // Init show toast message
  public static showToastsMesg(actionName: ActionState, input?: any) {
      switch (actionName) {
        case ActionState.DELETE: {
            if (input.multiple) {
                return {
                    type: NotificationType.SUCCESS,
                    title: CommonConstants.DELETE_SUCCESS_TITLE,
                    body: `<div id="toast-message-delete">${input.noOfSuccess + CommonConstants.DELETE_SUCCESS_BODY_MULTIPLE}</div>`
                };
            } else {
                return {
                    type: NotificationType.SUCCESS,
                    title: CommonConstants.DELETE_SUCCESS_TITLE,
                    body: `<div id="toast-message-delete">${CommonConstants.DELETE_SUCCESS_BODY_SINGLE}</div>`
                };
            }
        }
        case ActionState.DELETE_NO_REF: {
            if (input.multiple) {
                return {
                    type: NotificationType.SUCCESS,
                    title: CommonConstants.DELETE_SUCCESS_TITLE,
                    body: `<div id="toast-message-delete-noref">${CommonConstants.DELETE_NO_REF_SUCCESS_BODY_MULTIPLE}</div>`
                };
            } else {
                return {
                    type: NotificationType.SUCCESS,
                    title: CommonConstants.DELETE_SUCCESS_TITLE,
                    body: `<div id="toast-message-delete-noref">${CommonConstants.DELETE_NO_REF_SUCCESS_BODY_SINGLE}</div>`
                };
            }
        }
        case ActionState.UPDATE: {
            return {
                type: NotificationType.SUCCESS,
                title: CommonConstants.SAVE_SUCCESS_TITLE,
                body: `<div id="toast-message-update">${CommonConstants.SAVE_SUCCESS_SINGLE}</div>`
            };
        }
        case ActionState.NEW: {
            return {
                type: NotificationType.SUCCESS,
                title: CommonConstants.CREATE_SUCCESS_TITLE,
                body: `<div id="toast-message-new">${CommonConstants.CREATE_SUCCESS_SINGLE}</div>`
            };
        }
        case ActionState.UPLOAD: {
          return {
            type: NotificationType.SUCCESS,
            title: CommonConstants.UPLOAD_SUCCESS_TITLE,
            body: `<div id="toast-message-upload">${CommonConstants.UPLOAD_SINGLE_FILE_SUCCESS}</div>`
          };
        }
      }
  }
}
